import React, { Fragment, useEffect, useState, useContext, useRef, useCallback } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { MetadataComments } from "./MetadataComments";

export function Slider({ array, children, handleClick, activeSlideKey }) {
  const swiperRef = useRef(null);

  const [currentIndex, updateCurrentIndex] = useState(0);

  // const updateIndex = useCallback(
  //   (e) => {
  //     console.log(e)
  //     updateCurrentIndex(swiperRef.current.swiper.realIndex)},
  //   []
  // );

  // Add eventlisteners for swiper after initializing
  // useEffect(() => {
  //   const swiperInstance = swiperRef.current.swiper;

  //   if (swiperInstance) {
  //     swiperInstance.slideTo(currentIndex)
  //     swiperInstance.on("slideChange", (e) => {
  //       console.log(e);
  //     });
  //   }

  //   return () => {
  //     if (swiperInstance) {
  //       swiperInstance.off("slideChange", updateIndex);
  //     }
  //   };
  // }, [updateIndex]);

  useEffect(() => {
    const swiperInstance = swiperRef.current.swiper;
    if (swiperInstance) {
      console.log("activeSlideKey = ", activeSlideKey);
      swiperInstance.slideTo(activeSlideKey);
    }

    // if (activeSlideKey !== currentIndex) {
    //   debugger
    //   updateCurrentIndex(activeSlideKey)
    // }
  }, [activeSlideKey]);

  return (
    <>
      <div
        style={{
          position: "relative",
          width: "100%",
        }}
      >
        {/* {activeSlideKey} */}
        <Swiper
          ref={swiperRef}
          initialSlide={1}
          // spaceBetween={10}
          slidesPerView={4}
          activeSlideKey={activeSlideKey}
          slideToClickedSlide={true}
          // shouldSwiperUpdate
          // centeredSlides
          // onSlideChange={() =>console.log("slide change")}
          // onSwiper={(swiper) => console.log(swiper)}
        >
          {/* {children} */}

          {array.map((oneMetadata) => {
            // console.log("oneMetadata = ", oneMetadata);
            return (
              <>
                {oneMetadata && (
                  <>
                    <SwiperSlide key={oneMetadata["order"]}>
                      <MetadataComments
                        handleClick={handleClick}
                        {...oneMetadata}
                      />
                    </SwiperSlide>
                  </>
                )}
              </>
            );
          })}
        </Swiper>
      </div>
    </>
  );
}
